import { useState } from 'react';
import { api } from '../api';
const labels: Record<string, string> = {
  grant: '补发',
  revoke: '撤销',
  restore: '恢复',
  reset: '重新开放挑战',
};
export function AchievementHistory() {
  const [items, setItems] = useState<
      {
        seq: number;
        name: string;
        action: string;
        delta: number;
        reason: string;
        created_at: string;
      }[]
    >([]),
    [page, setPage] = useState(1),
    [loaded, setLoaded] = useState(false),
    [error, setError] = useState('');
  async function load(p: number) {
    try {
      setItems((await api<{ items: typeof items }>('/achievements/history?page=' + p)).items);
      setPage(p);
      setLoaded(true);
      setError('');
    } catch (e) {
      setError((e as Error).message);
    }
  }
  return (
    <details
      className="ach-player-history"
      onToggle={(e) => {
        if (e.currentTarget.open && !loaded) void load(1);
      }}
    >
      <summary>成就变更记录</summary>
      {error && <p role="alert">{error}</p>}
      {items.map((i) => (
        <article key={i.seq}>
          <strong>
            {i.name} · {labels[i.action]} {i.delta > 0 ? '+' : ''}
            {i.delta} 分
          </strong>
          <p>{i.reason}</p>
          <small>{new Date(i.created_at).toLocaleString()}</small>
        </article>
      ))}
      {loaded && !items.length && <p>暂无变更记录</p>}
      <div>
        <button disabled={page === 1} onClick={() => void load(page - 1)}>
          上一页
        </button>
        <button disabled={items.length < 30} onClick={() => void load(page + 1)}>
          下一页
        </button>
      </div>
    </details>
  );
}
